import { Box, Grid, makeStyles, Tab, Tabs } from '@material-ui/core'
import React from 'react'
import projectDashboards from '../../../assets/images/illustrations/project_dashboards.png'
import aprovalMatrix from '../../../assets/images/illustrations/aproval_matrix.png'
import preBuilt from '../../../assets/images/illustrations/pre_built.png'
import tablesFetures from '../../../assets/images/illustrations/tables_fetures_image.png'
function TabPanel(props) {
  const { children, value, index, ...other } = props
  const classes = useStyles()
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={classes.featuresImage}>{children}</Box>
      )}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  }
}

const useStyles = makeStyles((theme) => ({
  featuresTabsContainer: {
    flexGrow: 1,
    marginLeft: 'auto',
    display: 'flex',
    padding: '100px 0',
    [theme.breakpoints.down('1450')]: {
      width: 'calc(100% - 140px)',
    },
    [theme.breakpoints.up('1450')]: {
      width: 'calc(100% - 300px)',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 120,
    },
  },
  featuresImage: {
    textAlign: 'right',
    '& img': {
      maxWidth: '80%',
      [theme.breakpoints.down('md')]: {
        maxWidth: '93%',
      },
    },
  },
  featuresTabs: {
    borderLeft: `9px solid #6D42C7`,
    overflow: 'inherit !important',
    height: '100%',
    [theme.breakpoints.down('1280')]: {
      marginLeft: '10px',
    },
    '& .MuiTabs-flexContainerVertical': {
      height: '100%',
    },
    '& .MuiTabs-scroller': {
      overflow: 'inherit !important',
    },
    '& .MuiButtonBase-root': {
      textAlign: 'left',
      maxWidth: '100%',
      textTransform: 'capitalize',
      opacity: '1',
      paddingRight: 38,
      [theme.breakpoints.down('md')]: {
        paddingRight: 18,
      },
      '& .MuiTab-wrapper': {
        alignItems: 'flex-start',
        '& p': {
          fontSize: 26,
          fontWeight: 700,
          color: theme.palette.common.white,
          marginBottom: 20,
          lineHeight: '35px',
          [theme.breakpoints.down('xs')]: {
            fontSize: 24,
            marginBottom: 9,
          },
        },
        '& span': {
          fontSize: 16,
          fontWeight: 400,
          color: theme.palette.common.white,
          display: 'none',
        },
      },
      '&.Mui-selected': {
        height: 200,
        alignItems: 'self-start',
        [theme.breakpoints.down('md')]: {
          height: 180,
        },
        [theme.breakpoints.down('xs')]: {
          height: 'inherit',
        },
        '& .MuiTab-wrapper': {
          '& span': {
            display: 'block',
          },
        },
      },
    },
    '& .MuiTabs-indicator': {
      width: 9,
      left: '-9px',
      right: 'auto',
      backgroundColor: '#FF6879',
    },
  },
  featuresTabLink: {
    [theme.breakpoints.down('xs')]: {
      order: 2,
    },
  },
  featuresTabsContain: {
    [theme.breakpoints.down('xs')]: {
      order: 1,
      marginBottom: 30,
    },
  },
}))

const HomeFeatures = () => {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <>
      <div className={classes.featuresTabsContainer}>
        <Grid container alignItems="center">
          <Grid item sm={4} className={classes.featuresTabLink}>
            <Tabs
              orientation="vertical"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              className={classes.featuresTabs}
            >
              <Tab
                label={
                  <>
                    <p>Project dashboards</p>
                    <span>
                      View cost report summary information at a glance with our
                      customizable dashboards and indicators.
                    </span>
                  </>
                }
                {...a11yProps(0)}
              />
              <Tab
                label={
                  <>
                    <p>Approval Matrix</p>
                    <span>
                      Manage department and production approval chains easily
                      with our approval matrix
                    </span>
                  </>
                }
                {...a11yProps(1)}
              />
              <Tab
                label={
                  <>
                    <p>Pre-built and customizable forms</p>
                    <span>
                      Simplify the purchase order and payment request process
                      with digital forms.
                    </span>
                  </>
                }
                {...a11yProps(2)}
              />
              <Tab
                label={
                  <>
                    <p>Tables, views and File Manager</p>
                    <span>
                      View details and supporting documention on screen or
                      export to excel or PDF.
                    </span>
                  </>
                }
                {...a11yProps(3)}
              />
            </Tabs>
          </Grid>
          <Grid item sm={8} className={classes.featuresTabsContain}>
            <TabPanel value={value} index={0}>
              <img src={projectDashboards} alt="" />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <img src={aprovalMatrix} alt="" />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <img src={preBuilt} alt="" />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <img src={tablesFetures} alt="" />
            </TabPanel>
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default HomeFeatures
